var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXsynStackWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.925,
    height: 95.357,
    viewBox: "0 0 72.925 95.357",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XSYN_Stack_White",
    "data-name": "XSYN Stack White",
    transform: "translate(-14577.807 33.995)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_107477",
    "data-name": "Path 107477",
    d: "M3586.239,5364.523a1.6,1.6,0,0,0-1.135-.469h-2.123l-5.647-5.648a1.606,1.606,0,0,0-2.271,2.271l4.982,4.981-5,5a1.606,1.606,0,0,0,2.271,2.271l5.2-5.2a1.605,1.605,0,0,1,1.135-.47h.128a1.605,1.605,0,0,1,1.135.47l5.081,5.081a1.607,1.607,0,0,0,2.271,0h0a1.606,1.606,0,0,0,0-2.271Z",
    transform: "translate(11003.235 -5312.589)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107478",
    "data-name": "Path 107478",
    d: "M3921.511,5363.868a1.606,1.606,0,0,0,2.271,0l2.574-2.575a1.605,1.605,0,0,0,0-2.271h0a1.606,1.606,0,0,0-2.271,0l-2.574,2.574a1.605,1.605,0,0,0,0,2.271",
    transform: "translate(10669.214 -5313.184)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107479",
    "data-name": "Path 107479",
    d: "M4150.461,5341.47h-11.434a.741.741,0,0,0-.522.215l-3.318,3.318a.744.744,0,0,0-.216.523v4.542a.739.739,0,0,0,.738.738h10.91a.738.738,0,0,0,.737-.738v-1.736a.738.738,0,0,0-.737-.737h-7.7a.739.739,0,0,1-.522-1.261l1.438-1.437a.738.738,0,0,1,.522-.216h6.892a.737.737,0,0,1,.737.738h0a.739.739,0,0,0,.739.738h1.735a.738.738,0,0,0,.737-.738v-3.211a.738.738,0,0,0-.737-.739",
    transform: "translate(10462.97 -5296.715)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107480",
    "data-name": "Path 107480",
    d: "M4150.458,5614.387h-1.734a.739.739,0,0,0-.739.739v.623a.741.741,0,0,1-.216.523l-1.437,1.437a.739.739,0,0,1-.522.216h-6.892a.738.738,0,0,1-.739-.738.738.738,0,0,0-.738-.738h-1.735a.738.738,0,0,0-.738.738v3.212a.738.738,0,0,0,.738.738h11.433a.735.735,0,0,0,.522-.216l3.318-3.318a.74.74,0,0,0,.217-.523v-1.953a.739.739,0,0,0-.739-.739",
    transform: "translate(10462.972 -5559.826)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107481",
    "data-name": "Path 107481",
    d: "M4643.969,5363.863a1.606,1.606,0,0,0,2.271-2.271l-2.574-2.575a1.606,1.606,0,0,0-2.271,2.271Z",
    transform: "translate(9975.194 -5313.179)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107482",
    "data-name": "Path 107482",
    d: "M4657.454,5340.038h0a1.606,1.606,0,0,0-1.606,1.606v1.032a1.607,1.607,0,0,1-.47,1.136l-2.479,2.479a1.607,1.607,0,0,1-1.136.47h-1.875a1.6,1.6,0,0,0-1.135.471l-6.059,6.058a1.606,1.606,0,0,0,0,2.27h0a1.607,1.607,0,0,0,2.271,0l5.117-5.118a1.6,1.6,0,0,1,1.135-.47h1.875a1.6,1.6,0,0,0,1.135-.47l4.361-4.361a1.605,1.605,0,0,0,.47-1.135v-2.362a1.606,1.606,0,0,0-1.606-1.606",
    transform: "translate(9973.941 -5295.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107483",
    "data-name": "Path 107483",
    d: "M5160.71,5341.469H5150.5a1.6,1.6,0,0,0-1.136.471l-2.811,2.81a1.607,1.607,0,0,0-.471,1.135v10.585a1.606,1.606,0,1,0,3.212,0v-9.254a1.61,1.61,0,0,1,.471-1.136l.929-.929a1.6,1.6,0,0,1,1.136-.471h5.664a1.606,1.606,0,0,1,1.605,1.606v5.294a1.605,1.605,0,1,0,3.211,0v-8.5a1.607,1.607,0,0,0-1.606-1.607",
    transform: "translate(9488.181 -5296.714)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107484",
    "data-name": "Path 107484",
    d: "M5510.074,5714.492a1.6,1.6,0,1,0,1.6,1.6,1.6,1.6,0,0,0-1.6-1.6",
    transform: "translate(9138.817 -5656.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107485",
    "data-name": "Path 107485",
    d: "M3636.09,3154.054l7.122,7.122v3.546l-18.319,18.319-3.1,3.1,3.1,3.1,18.32,18.319v3.546l-7.122,7.122h-3.544l-18.32-18.32-3.1-3.1-3.1,3.1-18.319,18.319h-3.543l-7.122-7.122v-3.545l18.319-18.319,16.861-16.859,18.318-18.322Zm1.813-4.38h-7.171l-19.6,19.6-16.86,16.859-19.6,19.6v7.174l9.687,9.687h7.171l19.6-19.6,19.6,19.6h7.171l9.688-9.687v-7.174l-19.6-19.6,19.6-19.6v-7.173Z",
    transform: "translate(11003.141 -3183.669)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107486",
    "data-name": "Path 107486",
    d: "M3589.718,3154.054l11.559,11.559-10.666,10.667-11.558-11.558v-3.546l7.122-7.122Zm1.814-4.38h-7.172l-9.687,9.688v7.173l15.938,15.938,16.86-16.86Z",
    transform: "translate(11003.136 -3183.669)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXsynStackWhite);
export default __webpack_public_path__ + "static/media/XSYN Stack White.8d6370e4.svg";
export { ForwardRef as ReactComponent };